import Store from './Store'
import { computed, flow, makeObservable, observable } from 'mobx'
import EmailService from '../services/EmailService'
import Email from '../models/Email'

class EmailsStore extends Store {
  /**
   * @type {array<Email>}
   */
  @observable emails = []

  /**
   * @type {Email}
   */
  @observable email = new Email({})

  @computed
  get isDirty () {
    return this.email !== undefined ? this.email.isDirty : false
  }

  constructor () {
    super()
    makeObservable(this)
  }

  @flow
  * loadAll () {
    this.isLoading = true
    const result = yield EmailService.getEmails()
    this.emails = []
    for (const email of result.codes) {
      this.emails.push(new Email(email))
    }

    this.isLoading = false
  }

  @flow
  * loadOne (code) {
    this.isLoading = true
    const result = yield EmailService.getEmail(code)
    this.email = new Email(result.email)
    this.isLoading = false
  }

  @flow
  * save (code) {
    this.isSaving = true
    try {
      const response = yield EmailService.saveEmail(code, this.email.toJson())
      this.isSaving = false
      if (response.result.message) {
        this.addToast(response.result.message, response.result.success ? 'success' : 'error')
      }
      return response.result
    } catch (e) {
      this.addToast('Impossible de rejoindre le serveur en ce moment. Veuillez réessayer', 'error')
    }
  }
}

export default EmailsStore
